/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import loginReducer from "./loginReducer";
import appReducer from "./appReducer";
import resetPasswordReducer from "./resetPasswordReducer";
import assetListReducer from "./assetListReducer";
import assetReducer from "./assetReducer";
import userDetailReducer from "./userDetailReducer";
import deleteAssetReducer from "./deleteAssetReducer";
import uploadReducer from "./uploadReducer";
import accountReducer from "./accountReducer";
import accountLinkReducer from "./accountLinkReducer";
import accountFilterReducer from "./accountFilterReducer";
import transactionReducer from "./transactionReducer";
import cmsReducer from "./cmsReducer";
import attachmentReducer from "./attachmentReducer";
import notificationReducer from "./notificationReducer";
// import mortgageReducer from './mortgageReducer';
import sidebarReducer from "./sidebarReducer";
import contactsReducer from "./contactsReducer";
import assetSlugReducer from "./assetSlugReducer";
import assetBasicInfoReducer from "./assetBasicInfoReducer";
import assetInvestmentInfoReducer from "./assetInvestmentInfoReducer";
import assetMediaReducer from "./assetMediaReducer";
import assetFinancialReducer from "./assetFinancialReducer";
import accountDetailReducer from "./accountDetailReducer";
import assetExpensesReducer from "./assetExpensesReducer";
import assetIncomesReducer from "./assetIncomesReducer";
import assetValuationReducer from "./assetValuationReducer";
import statsReducer from "./statsReducer";
import checkAssetReducer from "./checkAssetReducer";
import resourcesReducer from "./resourcesReducer";
import recommendationReducer from "./recommendationReducer";
import exportReducer from "./exportReducer";
import reportReducer from "./reportReducer";
import chatReducer from "./chatReducer";
import inviteReducer from "./inviteReducer";
import dealReducer from "./dealReducer";
import checklistReducer from "./checklistReducer";
import propParser from "./propParser";
import reminderReducer from "./reminderReducer";
import missingImportReducer from "./missingImportReducer";
import partnerReducer from "./partnerReducer";
import ThemeOptions from "./themeOptions";
import documentReducer from "./documentsReducer";
import dashboardFilterReducer from "./dashboardFilterReducer";
import filterReducer from "./filterReducer";

const rootReducer = history =>
  combineReducers({
    login: loginReducer,
    app: appReducer,
    // forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    assetList: assetListReducer,
    asset: assetReducer,
    router: connectRouter(history),
    userDetail: userDetailReducer,
    deleteAssetReducer: deleteAssetReducer,
    upload: uploadReducer,
    plaid: accountReducer,
    accountLink: accountLinkReducer,
    transactions: transactionReducer,
    // resendEmail: resendEmailReducer,
    cms: cmsReducer,
    attachments: attachmentReducer,
    notifications: notificationReducer,
    // mortgage: mortgageReducer,
    sidebar: sidebarReducer,
    contacts: contactsReducer,
    assetSlug: assetSlugReducer,
    assetBasicInfo: assetBasicInfoReducer,
    assetInvestmentInfo: assetInvestmentInfoReducer,
    assetMedia: assetMediaReducer,
    financial: assetFinancialReducer,
    assetAccountDetail: accountDetailReducer,
    assetExpenses: assetExpensesReducer,
    assetIncomes: assetIncomesReducer,
    assetValuation: assetValuationReducer,
    statsReducer: statsReducer,
    checkAsset: checkAssetReducer,
    resources: resourcesReducer,
    recommendations: recommendationReducer,
    export: exportReducer,
    chat: chatReducer,
    invite: inviteReducer,
    deal: dealReducer,
    checklist: checklistReducer,
    propParser,

    reminders: reminderReducer,
    missingImport: missingImportReducer,
    partners: partnerReducer,
    ThemeOptions,
    documents: documentReducer,
    accountFilter: accountFilterReducer,
    dashboardFilter: dashboardFilterReducer,
    filter: filterReducer,
    report: reportReducer
  });

export default rootReducer;
